/** EvolveRPG — English overrides for the guided Play Now demo. Fast-play, momentum-driven voice.
 *  Only keys whose shared-shell value carried Grymwyrd flavor are overridden here — the demo's underlying
 *  mechanics (SRD 5.2.1 ability scores, initiative) are shared by every world and stay unchanged. */
export const demoEvoEn = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Play Now — Jump Into EvolveRPG',
  'demo.seoDescription':
    'Spin the world, claim a seat at the table, build a character in minutes, and roll the dice — a guided tour of the EvolveRPG virtual tabletop.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'The world of EvolveRPG',
  'demo.globe.tagline': 'A fast-play, multi-genre tabletop RPG',
  'demo.globe.heading': 'Find your table — any genre, right now',
  'demo.globe.subheading': 'A table is waiting. Take your seat and build a character in minutes.',
  'demo.globe.enterCta': 'Jump into EvolveRPG',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.subheading':
    "Create a free account to unlock the full EvolveRPG codex and save the character you're about to build — or step through as a guest and start playing now.",

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.lobbyEyebrow': 'EvolveRPG Virtual Tabletop · Lobby',
  'demo.create.heading': 'Build your character — fast',
  'demo.create.subheading': 'A character built in minutes, ready for any genre. Name them, pick a role, and roll the dice.',
  'demo.create.namePlaceholder': 'Who do you want to be tonight?',
  'demo.create.chooseCalling': 'Pick your role',
  'demo.create.keepStandard': 'Or keep the standard 10s and jump right in.',
  'demo.create.initiativeResult': 'Initiative {initiative} — dice are rolled, it’s go time…',
  'demo.create.chooseCallingHint': 'Pick a role to take your seat.',
  'demo.look.subheading': 'Pick one of Montkelian’s peoples, then a face. You will walk {city} as them.',
  'demo.look.lineages': 'Peoples of Montkelian',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.initiativePrompt': 'Roll to see who goes first — let’s move fast.',
  'demo.table.vttEyebrow': 'EvolveRPG VTT',
  'demo.table.saveHeroTitle': 'Create a free account to save your character',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.tagline': 'Your session’s highlight reel, the moment it wraps.',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.searchPlaceholder': 'Look up a rule, a move, a stat block…',
  'demo.reference.typeToSearch': 'Type at least two letters to search the EvolveRPG codex.',
  'demo.reference.notOwned':
    'You don’t own this book yet. The full reference unlocks once you add it to your library.',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.tagline': 'Rewatch the session, beat by beat.',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.body':
    "You're mid-session. This is a guest table — if you leave now, the session ends and your character is lost.",
}
